export class W3SearchButton {
  searchButton: HTMLElement | null;
  searchModal: HTMLElement | null;
  modalContent: HTMLElement | null;
  searchInput: HTMLInputElement | null; // Type as HTMLInputElement for access to 'value'
  startSearchButton: HTMLElement | null;
  closeButton: HTMLElement | null;

  constructor() {
    this.searchButton = document.querySelector(".search-button");
    this.searchModal = document.querySelector("#searchModal");
    this.modalContent = document.querySelector(".modal-content");

    this.searchInput = document.querySelector(
      "#search-modal-input--js",
    ) as HTMLInputElement;
    this.startSearchButton = document.querySelector("#search-icon-button--js"); // Ensure this selector is correct
    this.closeButton = document.querySelector(".modal-overlay__close--js");

    this.registerSearchEventHandler();
  }

  /**
   * registerSearchEventHandler - Register event handlers for the search component
   */
  registerSearchEventHandler(): void {
    if (!this.searchButton || !this.searchInput || !this.searchModal) return;

    this.searchButton.addEventListener("click", () => {
      this.toggleModal(); // Function to open/close modal
    });

    this.searchInput.addEventListener("keypress", (event: KeyboardEvent) => {
      event.stopPropagation();
      if (event.key === "Enter") {
        this.handleSearch();
      }
    });

    if (this.startSearchButton) {
      this.startSearchButton.addEventListener("click", (event) => {
        event.stopPropagation();
        this.handleSearch();
      });
    }

    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this.toggleModal(false);
      });
    }

    this.modalContent.addEventListener("click", (event) => {
      if (event.target === this.modalContent) {
        this.toggleModal(false); // Close the modal
      }
    });
  }

  /**
   * toggleModal - Toggle the search modal
   * @param {boolean} [open] - Optional directive to explicitly open/close the modal
   * @returns {void}
   */
  toggleModal(open?: boolean): void {
    const isActive: boolean = this.searchModal!.classList.contains("active");
    if (open === undefined) {
      open = !isActive; // Toggle based on current state if no explicit directive
    }
    if (open) {
      this.searchModal?.classList.add("active");
      document.body.style.overflow = "hidden";
      document.body.style.height = "100dvh";
    } else {
      this.searchModal?.classList.remove("active");
      document.body.style.overflow = "";
      document.body.style.height = "";
    }
  }

  /**
   * handleSearch - Handle the search input value and redirect to the search results page
   * @returns {void}
   */
  handleSearch(): void {
    if (!this.searchInput) return;
    const query = this.searchInput.value.trim();
    if (query.length > 0) {
      const wpSearchUrl: string = `/?s=${query}`;
      window.location.href = wpSearchUrl;
    }
  }
}
